import { useParams } from "react-router-dom";
import { useGetVideoQuery } from "../../../../features/video/videoApi";
import EmptyResult from "../../../ui/EmptyResult";
import Error from "../../../ui/Error";
import Loading from "../../../ui/Loading";
import EditVideoForm from "./EditVideoForm";

export default function EditVideo() {
	const { videoId } = useParams();
    const { data: video, isLoading, isError } = useGetVideoQuery(videoId) || {};

    let content = null;
	if (isLoading) {
		content = <Loading />;
	}
	else if (!isLoading && isError) {
		content = <Error message="There was an error getting the videos!" />;
	}
	else if (!isLoading && !isError && video === undefined) {
		content = <EmptyResult message="No video found!, please try again" />;
	}
    else if (!isLoading && !isError && video !== undefined) {
        content = <EditVideoForm video={video} />
    }

	return (
        <>
            {content}
        </>
    );
}
